import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import Layout from '../../components/common/Layout/Layout';

const ImportantLinksPage = () => {
    const governmentBodies = [
        { name: 'Government of India', url: 'https://www.india.gov.in/' },
        { name: 'Ministry of Finance', url: 'https://www.finmin.nic.in/' },
        { name: 'Ministry of Corporate Affairs', url: 'https://www.mca.gov.in/' },
        { name: 'MoF – Department of Financial Services', url: 'https://financialservices.gov.in/' },
        { name: 'Income Tax Department', url: 'https://www.incometax.gov.in/' },
        { name: 'Central Board of Excise & Customs', url: 'https://www.cbic.gov.in/' },
        { name: 'Securities & Exchange Board of India (SEBI)', url: 'https://www.sebi.gov.in/' },
        { name: 'Insurance Regulatory & Development Authority (IRDA)', url: 'https://www.irdai.gov.in/' },
        { name: 'Reserve Bank of India (RBI)', url: 'https://www.rbi.org.in/' },
        { name: 'Pension Fund Regulatory and Development Authority (PFRDA)', url: 'https://www.pfrda.org.in/' }
    ];

    const securitiesMarket = [
        { name: 'National Stock Exchange (NSE)', url: 'https://www.nseindia.com/' },
        { name: 'Bombay Stock Exchange (BSE)', url: 'https://www.bseindia.com/' },
        { name: 'Multi Commodity Exchange of India Ltd (MCX)', url: 'https://www.mcxindia.com/' },
        { name: 'National Commodity and Derivatives Exchange (NCDEX)', url: 'https://www.ncdex.com/' },
        { name: 'Over the Counter Exchange of India (OTCEI)', url: 'https://www.otcei.in/' },
        { name: 'Inter-connected Stock Exchange of India Limited (ISE)', url: 'https://www.iseindia.com/' },
        { name: 'Stock Holding Corporation of India', url: 'https://www.stockholding.com/' },
        { name: 'National Securities Depository Ltd. (NSDL)', url: 'https://www.nsdl.co.in/' },
        { name: 'Central Depository Services (India) Ltd.', url: 'https://www.cdslindia.com/' }
    ];

    const industryBodies = [
        { name: 'Financial Intermediaries Association of India', url: 'https://www.fiai.co.in/' },
        { name: 'Association of Mutual Funds in India', url: 'https://www.amfiindia.com/' },
        { name: 'Life Insurance Council', url: 'https://www.lifeinsurancecouncil.org/' },
        { name: 'General Insurance Council', url: 'https://www.gicouncil.in/' },
        { name: 'Insurance Brokers Association of India (IBAI)', url: 'https://www.ibai.org/' },
        { name: 'Indian Banks Association', url: 'https://www.iba.org.in/' },
        { name: 'Federation of Indian Chambers of Commerce & Industry (FICCI)', url: 'https://www.ficci.in/' },
        { name: 'The Associated Chambers of Commerce & Industry in India (ASSOCHAM)', url: 'https://www.assocham.org/' },
        { name: 'Confederation of Indian Industry (CII)', url: 'https://www.cii.in/' }
    ];

    const informationResources = [
        { name: 'Government of India – Web Directory', url: 'https://goidirectory.gov.in/' },
        { name: 'Union Budget & Economic Survey', url: 'https://www.indiabudget.gov.in/' },
        { name: 'Press Information Bureau, Govt. Of India', url: 'https://pib.gov.in/' },
        { name: 'Census of India', url: 'https://censusindia.gov.in/' },
        { name: 'Right to Information Act', url: 'https://rti.gov.in/' },
        { name: 'Business in India – Govt. Initiative', url: 'https://www.business.gov.in/' },
        { name: 'Invest India', url: 'https://www.investindia.gov.in/' },
        { name: 'National Centre for Trade Information', url: 'https://www.ncti-india.org/' },
        { name: 'Invest India Economic Foundation', url: 'https://www.iief.co.in/' },
        { name: 'India Trade Promotion Organisation (ITPO)', url: 'https://www.indiatradefair.com/' },
        { name: 'Indian Brand Equity Foundation (IBEF)', url: 'https://www.ibef.org/' }
    ];

    const assetManagementCompanies = [
        { name: 'Axis Asset Management Company Ltd.', url: 'https://www.axismf.com/' },
        { name: 'Baroda Pioneer Asset Management Company Limited', url: 'https://www.barodapioneer.in/' },
        { name: 'Birla Sun Life Asset Management Company Limited', url: 'https://www.birlasunlife.com/' },
        { name: 'BNP Paribas Asset Management India Private Limited', url: 'https://www.bnpparibas-am.in/' },
        { name: 'BOI AXA Investment Managers Private Limited', url: 'https://www.boiaxamf.in/' },
        { name: 'Canara Robeco Asset Management Company Limited', url: 'https://www.canararobeco.com/' },
        { name: 'Daiwa Asset Management (India) Private Limited', url: 'https://www.daiwaasset.co.in/' },
        { name: 'Deutsche Asset Management (India) Pvt. Ltd.', url: 'https://www.deutscheam.in/' },
        { name: 'DSP BlackRock Investment Managers Private Limited', url: 'https://www.dspblackrock.com/' },
        { name: 'Edelweiss Asset Management Limited', url: 'https://www.edelweissmf.com/' },
        { name: 'Escorts Asset Management Limited', url: 'https://www.escortsmutualfund.com/' },
        { name: 'Franklin Templeton Asset Management (India) Private Limited', url: 'https://www.franklintempletonindia.com/' },
        { name: 'Goldman Sachs Asset Management (India) Private Limited', url: 'https://www.gsam.com/' },
        { name: 'HDFC Asset Management Company Limited', url: 'https://www.hdfcfund.com/' },
        { name: 'HSBC Asset Management (India) Private Ltd.', url: 'https://www.assetmanagement.hsbc.co.in/' },
        { name: 'ICICI Prudential Asset Mgmt.Company Limited', url: 'https://www.icicipruamc.com/' },
        { name: 'IDBI Asset Management Ltd.', url: 'https://www.idbimutualfund.co.in/' },
        { name: 'IDFC Asset Management Company Limited', url: 'https://www.idfcamc.com/' },
        { name: 'IL&FS Infra Asset Management Limited', url: 'https://www.ilfsinframf.com/' },
        { name: 'India Infoline Asset Management Co. Ltd.', url: 'https://www.iiflmf.com/' },
        { name: 'Indiabulls Asset Management Company Ltd.', url: 'https://www.indiabullsmf.com/' },
        { name: 'ING Investment Management (India) Pvt. Ltd.', url: 'https://www.ingim.co.in/' },
        { name: 'JM Financial Asset Management Private Limited', url: 'https://www.jmfinancialmf.com/' },
        { name: 'JPMorgan Asset Management India Pvt. Ltd.', url: 'https://www.jpmorganmf.com/' },
        { name: 'Kotak Mahindra Asset Management Company Limited(KMAMCL)', url: 'https://www.kotakmf.com/' },
        { name: 'L&T Investment Management Limited', url: 'https://www.ltfs.com/' },
        { name: 'LIC NOMURA Mutual Fund Asset Management Company Limited', url: 'https://www.licnomura.com/' },
        { name: 'Mirae Asset Global Investments (India) Pvt. Ltd.', url: 'https://www.miraeassetmf.co.in/' },
        { name: 'Morgan Stanley Investment Management Pvt.Ltd.', url: 'https://www.morganstanley.com/' },
        { name: 'Motilal Oswal Asset Management Company Limited', url: 'https://www.motilaloswalmf.com/' },
        { name: 'Peerless Funds Management Co. Ltd.', url: 'https://www.peerlessmf.co.in/' },
        { name: 'PineBridge Investments Asset Management Company (India) Pvt. Ltd.', url: 'https://www.pinebridge.co.in/' },
        { name: 'PPFAS Asset Management Pvt. Ltd.', url: 'https://www.ppfas.com/' },
        { name: 'Pramerica Asset Managers Private Limited', url: 'https://www.pramericamf.com/' },
        { name: 'Principal Pnb Asset Management Co. Pvt. Ltd.', url: 'https://www.principalindia.com/' },
        { name: 'Quantum Asset Management Company Private Limited', url: 'https://www.quantumamc.com/' },
        { name: 'Reliance Capital Asset Management Ltd.', url: 'https://www.reliancemutual.com/' },
        { name: 'Religare Invesco Asset Management Company Private Limited', url: 'https://www.religareinvesco.com/' },
        { name: 'Sahara Asset Management Company Private Limited', url: 'https://www.saharamutual.com/' },
        { name: 'SBI Funds Management Private Limited', url: 'https://www.sbimf.com/' },
        { name: 'Sundaram Asset Management Company Limited', url: 'https://www.sundarammutual.com/' },
        { name: 'Tata Asset Management Limited', url: 'https://www.tatamutualfund.com/' },
        { name: 'Taurus Asset Management Company Limited', url: 'https://www.taurusmutualfund.com/' },
        { name: 'Union KBC Asset Management Company Private Limited', url: 'https://www.unionkbc.com/' },
        { name: 'UTI Asset Management Company Ltd', url: 'https://www.utimf.com/' }
    ];

    const lifeInsuranceCompanies = [
        { name: 'AEGON Religare Life Insurance Company Limited.', url: 'https://www.aegonlife.com/' },
        { name: 'Aviva Life Insurance Company India Limited', url: 'https://www.avivaindia.com/' },
        { name: 'Bajaj Allianz Life Insurance Company Limited', url: 'https://www.bajajallianzlife.com/' },
        { name: 'Bharti AXA Life Insurance Company Ltd.', url: 'https://www.bharti-axalife.com/' },
        { name: 'Birla Sun Life Insurance Co. Ltd', url: 'https://www.birlasunlife.com/' },
        { name: 'Canara HSBC Oriental Bank of Commerce Life Insurance Company Ltd.', url: 'https://www.canarahsbclife.in/' },
        { name: 'DLF Pramerica Life Insurance Co. Ltd.', url: 'https://www.dlfpramerica.com/' },
        { name: 'Edelweiss Tokio Life Insurance Co. Ltd.', url: 'https://www.edelweisstokio.in/' },
        { name: 'Future Generali India Life Insurance Company Limited', url: 'https://www.futuregenerali.in/' },
        { name: 'HDFC Standard Life Insurance Co. Ltd', url: 'https://www.hdfclife.com/' },
        { name: 'ICICI Prudential Life Insurance Co. Ltd', url: 'https://www.iciciprulife.com/' },
        { name: 'IDBI Federal Life Insurance Company Ltd.', url: 'https://www.idbifederal.com/' },
        { name: 'IndiaFirst Life Insurance Company Limited', url: 'https://www.indiafirstlife.com/' },
        { name: 'ING Vysya Life Insurance Company Ltd.', url: 'https://www.inglife.co.in/' },
        { name: 'Kotak Mahindra Old Mutual Life Insurance Limited', url: 'https://www.kotaklife.com/' },
        { name: 'Life Insurance Corporation of India', url: 'https://www.licindia.in/' },
        { name: 'Max Life Insurance Co. Ltd', url: 'https://www.maxlifeinsurance.com/' },
        { name: 'Met Life India Insurance Company Ltd.', url: 'https://www.metlife.co.in/' },
        { name: 'Reliance Life Insurance Company Limited.', url: 'https://www.reliancelife.com/' },
        { name: 'Sahara India Life Insurance Co, Ltd.', url: 'https://www.saharaindia.com/' },
        { name: 'SBI Life Insurance Co. Ltd', url: 'https://www.sbilife.co.in/' },
        { name: 'Shriram Life Insurance Co, Ltd.', url: 'https://www.shriramlife.in/' },
        { name: 'Star Union Dai-ichi Life Insurance Co. Ltd.', url: 'https://www.sudlife.in/' },
        { name: 'Tata AIA Life Insurance Company Limited', url: 'https://www.tataaia.com/' }
    ];

    const nonLifeInsuranceCompanies = [
        { name: 'Agriculture Insurance Co. of India Ltd.', url: 'https://www.aicofindia.com/' },
        { name: 'Apollo Munich Health Insurance Company Limited', url: 'https://www.apollomunichinsurance.com/' },
        { name: 'BajajAllianz General Insurance Co. Ltd.', url: 'https://www.bajajallianz.com/' },
        { name: 'BhartiAXA General Insurance Company Limited', url: 'https://www.bharti-axa.co.in/' },
        { name: 'CholamandalamMS General Insurance Co. Ltd.', url: 'https://www.cholams.co.in/' },
        { name: 'Export Credit Guarantee Corporation of India Ltd.', url: 'https://www.ecgc.in/' },
        { name: 'Future Generali India Insurance Company Limited', url: 'https://www.futuregenerali.in/' },
        { name: 'HDFC ERGO General Insurance Co. Ltd.', url: 'https://www.hdfcergo.com/' },
        { name: 'IFFCO Tokio General Insurance Co. Ltd', url: 'https://www.iffcotokio.co.in/' },
        { name: 'L&T General Insurance Company Limited', url: 'https://www.lntgeneralinsurance.com/' },
        { name: 'Liberty Videocon General Insurance Company Limited', url: 'https://www.libertyinsurance.in/' },
        { name: 'Magma HDI General Insurance Company Limited', url: 'https://www.magmahdi.com/' },
        { name: 'Max Bupa Health Insurance Company Ltd.', url: 'https://www.maxbupa.com/' },
        { name: 'National Insurance Co. Ltd.', url: 'https://www.nationalinsuranceindia.com/' },
        { name: 'Raheja QBE General Insurance Company Limited', url: 'https://www.rahejainsurance.com/' },
        { name: 'Reliance General Insurance Co. Ltd.', url: 'https://www.reliancegeneral.co.in/' },
        { name: 'Religare Health Insurance Company Limited', url: 'https://www.religarehealth.com/' },
        { name: 'Royal Sundaram Alliance Insurance Co. Ltd', url: 'https://www.royalsundaram.in/' },
        { name: 'SBI General Insurance Company Limited', url: 'https://www.sbigeneral.in/' },
        { name: 'ShriramGeneral Insurance Company Limited', url: 'https://www.shriramgi.in/' },
        { name: 'Star Health and Allied Insurance Company Limited', url: 'https://www.starhealth.in/' },
        { name: 'TataAIG General Insurance Co. Ltd.', url: 'https://www.tataaig.com/' },
        { name: 'The New India Assurance Co. Ltd.', url: 'https://www.newindia.co.in/' },
        { name: 'The Oriental Insurance Co. Ltd.', url: 'https://www.orientalinsurance.org.in/' }
    ];

    const styles = {
        pageContainer: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ffffff'
        },
        
        mainContent: {
            flex: 1,
            backgroundColor: '#f8fafc',
            padding: '3rem 0'
        },

        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 2rem'
        },

        sectionContainer: {
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            padding: '2.5rem',
            marginBottom: '2.5rem',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e2e8f0'
        },

        sectionTitle: {
            fontSize: '1.75rem',
            fontWeight: '700',
            color: '#1a202c',
            marginBottom: '1.5rem',
            borderBottom: '2px solid #22c55e',
            paddingBottom: '0.75rem',
            display: 'inline-block'
        },

        linksList: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '0.75rem',
            marginTop: '1rem'
        },

        linkItem: {
            display: 'flex',
            alignItems: 'center',
            padding: '0.75rem 1rem',
            backgroundColor: '#f7fafc',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            textDecoration: 'none',
            color: '#4a5568'
        },

        linkIcon: {
            width: '16px',
            height: '16px',
            marginRight: '0.75rem',
            backgroundColor: '#22c55e',
            borderRadius: '2px',
            flexShrink: 0,
            position: 'relative'
        },

        linkText: {
            fontSize: '0.95rem',
            lineHeight: '1.4',
            color: '#4a5568',
            fontWeight: '500'
        }
    };

    const LinkItem = ({ name, url }) => (
        <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={styles.linkItem} 
            className="link-item"
        >
            <div style={styles.linkIcon}></div>
            <span style={styles.linkText}>{name}</span>
        </a>
    );

    return (
        <>
            <style>{`
                .link-item:hover {
                    background-color: #edf2f7;
                    border-color: #22c55e;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }

                .link-item:hover .link-text {
                    color: #22c55e;
                }

                @media (max-width: 768px) {
                    .container {
                        padding: 0 1rem !important;
                    }
                    
                    .section-container {
                        padding: 1.5rem !important;
                        margin-bottom: 1.5rem !important;
                    }
                    
                    .section-title {
                        font-size: 1.5rem !important;
                    }
                    
                    .links-list {
                        grid-template-columns: 1fr !important;
                    }
                    
                    .main-content {
                        padding: 2rem 0 !important;
                    }
                }

                @media (max-width: 640px) {
                    .section-title {
                        font-size: 1.25rem !important;
                    }
                    
                    .link-item {
                        padding: 0.5rem 0.75rem !important;
                    }
                    
                    .link-text {
                        font-size: 0.9rem !important;
                    }
                }
            `}</style>

            <div style={styles.pageContainer}>
                {/* Header */}
                <Header />

                {/* Main Content */}
                <main style={styles.mainContent} className="main-content">
                    <div style={styles.container} className="container">
                        
                        {/* Government Bodies Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Government Bodies / Regulators in India
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {governmentBodies.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                        {/* Securities Market Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Securities Market
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {securitiesMarket.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                        {/* Industry Bodies Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Industry Bodies / Associations
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {industryBodies.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                        {/* Information Resources Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Information Resources
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {informationResources.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                        {/* Asset Management Companies Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Asset Management Companies
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {assetManagementCompanies.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                        {/* Life Insurance Companies Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Life Insurance Companies
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {lifeInsuranceCompanies.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                        {/* Non-Life Insurance Companies Section */}
                        <section style={styles.sectionContainer} className="section-container">
                            <h2 style={styles.sectionTitle} className="section-title">
                                Non – Life Insurance Companies
                            </h2>
                            <div style={styles.linksList} className="links-list">
                                {nonLifeInsuranceCompanies.map((item, index) => (
                                    <LinkItem key={index} name={item.name} url={item.url} />
                                ))}
                            </div>
                        </section>

                    </div>
                </main>

                {/* Layout */}
                <Layout />

                {/* Footer */}
                <Footer />
            </div>
        </>
    );
};

export default ImportantLinksPage;